export const CALL_STAT_COLUMNS = [
  { headerLabel: "Contacts", rowLabel: "Total Contacts", getValue: (p) => p.totalContacts },
  {
    headerLabel: "Responded",
    rowLabel: "Responded Users",
    getValue: (p) => p.callCampaignDetails.callsCompleted,
  },
  {
    headerLabel: "Attempted",
    rowLabel: "Attempted Calls",
    getValue: (p) => p.callCampaignDetails.callsAttempted,
  },
  {
    headerLabel: "Failed",
    rowLabel: "Failed Calls",
    getValue: (p) => p.callCampaignDetails.callsFailed,
  },
  {
    headerLabel: "No Answer",
    rowLabel: "Not Answered",
    getValue: (p) => p.callCampaignDetails.callsNotAnswered,
  },
  {
    headerLabel: "Blocked",
    rowLabel: "Blocked Calls",
    getValue: (p) => p.callCampaignDetails.callsBlocked,
  },
  {
    headerLabel: "Voicemail",
    rowLabel: "Voicemail / Hold",
    getValue: (p) => p.callCampaignDetails.voicemail,
  },
];

export const CALL_ROW_GRID_COLS =
  "grid-cols-[minmax(220px,2fr)_repeat(7,minmax(70px,1fr))_minmax(170px,auto)]";

// campaign(220) + 7 stats(70 each) + actions(170) + 8 gaps(16 each) + row padding(32)
export const CALL_ROW_MIN_WIDTH = 220 + 7 * 70 + 170 + 8 * 16 + 32;
